<template>
  <base-cell
    @click="$emit('click')"
  >
    <div
      class="team-cell"
      :class="{
        'team-cell--is-small': !responsive.lg
      }"
    >
      <!-- 74 ipad / 84 desktop -->
      <base-avatar
        background-color="#ECEBE8"
        class="team-cell__avatar"
        :username="username"
        :img="img"
        :size="responsive.lg ? 84: 74"
      />
      <div>
        <base-text regular>
          {{ username }}
        </base-text>
        <base-text
          trim
          :max-width="200"
          class="member-email mr-2"
          size="md"
          light
          muted
        >
          {{ user.email }}
        </base-text>
      </div>
      <div class="team-cell__right">
        <div class="team-cell__values">
          <base-text
            size="xs"
            muted
            light
            class="team-cell__key"
          >
            last active
          </base-text>
          <base-text
            size="s"
            light
            nowrap
            :class="`team-cell__value`"
          >
            <template v-if="lastActive">
              {{ niceDate(lastActive) }}
            </template>
            <template v-else>
              -
            </template>
          </base-text>
        </div>
        <div class="team-cell__values">
          <base-text
            size="xs"
            muted
            light
            class="team-cell__key"
          >
            clients assigned
          </base-text>
          <base-text
            size="s"
            light
            class="team-cell__value"
          >
            {{ clientsAssigned }}
          </base-text>
        </div>
        <div class="team-cell__values">
          <base-text
            size="xs"
            muted
            light
            class="team-cell__key"
          >
            based in
          </base-text>
          <base-text
            size="s"
            light
            class="team-cell__value"
          >
            {{ basedIn ? basedIn:"-" }}
          </base-text>
        </div>
      </div>
    </div>
  </base-cell>
</template>
<script>
import responsive from '@/components/mixins/responsive';

export default {
  mixins: [responsive],
  props: {
    user: {
      type: Object,
      default: () => ({
        first_name: '',
        last_name: '',
        email: '',
      }),
    },

    img: {
      type: String,
      default: '',
    },

    lastActive: {
      type: String,
      default: '-',
    },
    clientsAssigned: {
      type: [String, Number],
      default: 0,
    },
    basedIn: {
      type: String,
      default: '',
    },
  },
  computed: {
    username() {
      return `${this.user.first_name} ${this.user.last_name}`;
    },
  },
  methods: {
    // Not using textMixin 'nicedate' filter. Super custom behavior.
    niceDate(date) {
      const past24hrs = this.$moment().subtract(24, 'hours');
      if (this.$moment(date).isAfter(past24hrs)) {
        return this.$moment(date).fromNow();
      }
      return this.$moment(date).format('MMM Do, YYYY');
    },
  },
};
</script>
<style lang="scss"
  scoped>
.team-cell {
  display: grid;
  column-gap: 20px;
  grid-template-columns: 84px 1fr 200px;
  align-items: center;

  padding: 0.75rem 0;
  cursor: pointer;
  transition: background 0.3s;
  width: 100%;
  min-height: 100px;

  &--is-small{
    grid-template-columns: 74px 1fr 150px;
    column-gap: 9px;
  }

  .member-email {
    letter-spacing: -0.34px;
  }

  &__right {
    display: grid;
    row-gap: 0.5rem;
  }
  &__values {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 10px;
    align-items: baseline;
  }

  &--is-small &__values {
    grid-template-columns: 1fr;
  }

  &__key {
    color: $gray-light-2;
    text-transform: uppercase;
    font-size: 0.625rem;
  }

  &__value {
    color: $gray;
    margin-bottom: 0;
  }

}
</style>
